import { useTranslation } from "react-i18next";
import { getContent } from "../data/content";

/**
 * Returns the language-aware long-form content bundle, refreshed
 * automatically when the user switches languages.
 *
 * Usage:
 *   const { LIBRARY, SANCTUARY, BEFORE_YOU_GO_BACK, FINANCIAL, HOTLINES } = useContent();
 */
export function useContent() {
  const { i18n } = useTranslation();
  return getContent(i18n.language);
}
